import React from "react";
import { Box } from "digiwash-components";

interface PropsType {
  children: React.ReactNode;
}

function HeaderContainer(props: PropsType) {
  return (
    <Box bg="primary.main" style={{ paddingBottom: 76 }}>
      {props.children}
    </Box>
  );
}

export default HeaderContainer;
